// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"stories_scrollbar__25BBm"};